import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

const backgroundColorPaletteOptions = [
   'primary',
   'primary-lighten-20',
   'primary-lighten-40',
   'primary-darken-20',
   'primary-darken-40',
   'secondary',
   'alert',
   'alert-light',
   'alert-dark',
   'success',
   'success-light',
   'success-dark',
   'text-primary',
   'text-secondary',
   'text-accent',
   'menu',
   'menu-brand',
   'accent-darken-20',
   'accent-darken-40',
   'warning',
   'warning-light',
   'warning-darken-20',
   'warning-darken-40',
];

/**
 * Displays an avatar showing either the person's initials, or their picture (if available)
 * Accessibility: ndt-avatar should always be given an aria-label or aria-labelledby
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        role: 'img',
    },
    selector: 'ndt-avatar',
    styleUrls: ['./avatar.component.scss'],
    templateUrl: './avatar.component.html',
    standalone: false
})
export class AvatarComponent {
   @Input() fileToken: string | null;

   @Input() set name(value: string | null) {
      this._name = value;

      if (this._name) {
         this.background = this.getColorForUserNameHash(this._name);
      }
   }

   get name(): string | null {
      return this._name;
   }

   @HostBinding('class') background = '';

   error = false;

   loaded = false;

   // eslint-disable-next-line @typescript-eslint/naming-convention
   private _name: string | null = null;

   onError(): void {
      this.fileToken = null;
      this.error = true;
   }

   onLoad(): void {
      this.loaded = true;
   }

   private getColorForUserNameHash(userName: string): string {
      const index =
         Math.abs(
            userName.split('').reduce((prev, curr) => {
               return (Math.imul(31, prev) + curr.charCodeAt(0)) | 0;
            }, 0)
         ) % backgroundColorPaletteOptions.length;

      return backgroundColorPaletteOptions[index];
   }
}
